import { TabPanel, TabPanelProps } from '@chakra-ui/react';
import React from 'react';

export const CmTabPanel: React.FC<TabPanelProps> = ({ ...rest }) => {
  // @ts-ignore TS2590
  return <TabPanel padding={0} {...rest} />;
};
